import React, { useState } from 'react';
import { HiEye, HiEyeSlash, HiCheckCircle, HiXCircle } from 'react-icons/hi2';
import { checkPassword } from '@ikhua/shared';

export default function PasswordInput({ label = 'Password', value, onChange, showRules = true, placeholder = '••••••••' }) {
  const [show, setShow] = useState(false);
  const rules = checkPassword(value || '');
  const hasInput = (value || '').length > 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {label && (
        <label style={{ fontSize: '13px', fontWeight: 600, color: '#8B8FA8', paddingLeft: 2 }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="input"
          style={{ paddingRight: 48 }}
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#4B5170', cursor: 'pointer', display: 'flex', padding: 0 }}
        >
          {show ? <HiEyeSlash size={18} /> : <HiEye size={18} />}
        </button>
      </div>

      {/* Live rules checklist — shown once user starts typing */}
      {showRules && hasInput && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '10px 12px', background: '#1A1748', borderRadius: 12, marginTop: 2 }}>
          {rules.map(rule => (
            <div key={rule.label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {rule.passed
                ? <HiCheckCircle size={14} style={{ color: '#10B981', flexShrink: 0 }} />
                : <HiXCircle    size={14} style={{ color: '#EF4444', flexShrink: 0 }} />}
              <span style={{ fontSize: '12px', color: rule.passed ? '#10B981' : '#EF4444' }}>
                {rule.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
